__turbopack_context__.v({
  "availability": "F_diqa_availability",
  "bundle-offer-content": "F_diqa_bundle-offer-content",
  "bundle-offer-heading": "F_diqa_bundle-offer-heading",
  "description": "F_diqa_description",
  "desktop": "F_diqa_desktop",
  "discount-notice-bolded": "F_diqa_discount-notice-bolded",
  "discount-notice-container": "F_diqa_discount-notice-container",
  "discount-notice-wrapper": "F_diqa_discount-notice-wrapper",
  "feature-list": "F_diqa_feature-list",
  "is-selected": "F_diqa_is-selected",
  "mobile": "F_diqa_mobile",
  "pick-button": "F_diqa_pick-button",
  "plan": "F_diqa_plan",
  "plans": "F_diqa_plans",
  "price": "F_diqa_price",
  "pricing": "F_diqa_pricing",
  "pricing-overview": "F_diqa_pricing-overview",
  "pricing-toggle": "F_diqa_pricing-toggle",
  "pricing-toggle-wrapper": "F_diqa_pricing-toggle-wrapper",
  "primary-pick-button": "F_diqa_primary-pick-button",
  "recommended": "F_diqa_recommended",
  "single-price": "F_diqa_single-price",
  "table-wrapper": "F_diqa_table-wrapper",
  "wrapper": "F_diqa_wrapper",
});
